import { PumsemLayoutView } from '@/features/pumsem';
import { ScrollToTop } from '@/app/layouts/utils/ScrollToTop.tsx';
import { RouteLoadingOverlay } from '@/app/layouts/utils/RouteLoadingOverlay.tsx';

/**
 * `/pumsem/*` 전용 레이아웃.
 *
 * `MainLayout` 을 쓰지 않는 이유는 도움말과 같다 — 메가메뉴가 결과 목록과
 * sticky 본문 위로 펼쳐진다. 다만 여기서는 검색창이 헤더의 주인공이라
 * 헤더 자체가 화면의 도구다.
 *
 * `ScrollToHash` 는 빼둔다 — 이 화면에는 목차가 없고, 표 안에서 앵커로 뛰는
 * 동작도 없다. 넣어두면 검색 조건이 바뀔 때마다 헛일을 한다.
 */
export default function PumsemLayout() {
  return (
    <>
      <ScrollToTop />
      <RouteLoadingOverlay />
      <PumsemLayoutView />
    </>
  );
}
